module.exports = __webpack_public_path__ + "assets/15fc0c51caa5b91cf868781891e303dd.svg";